export default __webpack_public_path__ + "static/media/chimeron.837d16a0.png";